import type { IAddress } from "@bbj-types/address";
import type { ICandidate } from "@bbj-types/candidate";
import type { DocumentTypes } from "@bbj-types/document/enum";
import type { IUser } from "@bbj-types/user";
import type { ObjectId } from "@bbj-types/utils";

export enum WorkshopInvitationStatus {
  TO_INVITE = "toInvite",
  INVITED = "invited",
  ACCEPTED = "accepted",
  DENIED = "denied",
  OTHER = "otherAnswer",
}

export enum ParticipantStatus {
  PRESENT = "present",
  EXCUSED_ABSENCE = "excusedAbsence",
  UNEXCUSED_ABSENCE = "unexcusedAbsence",
}

export interface ILastCommunication {
  date: Date;
  type: "sms" | "email" | "mail";
  name?: string;
}

export interface IWorkshopParticipant {
  _id: ObjectId;
  address: ICandidate["address"];
  candidate: ObjectId;
  coachingStep: ICandidate["coachingStep"];
  firstName: ICandidate["firstName"];
  isPresent: boolean;
  lastName: ICandidate["lastName"];
  mail: ICandidate["mail"];
  optInEmail: boolean;
  optInPhone: ICandidate["optInPhone"];
  phone: ICandidate["phone"];
  convocationTime?: ObjectId;
  invitationStatus?: WorkshopInvitationStatus;
  lastCommunication?: ILastCommunication;
  presenceTime?: number;
  justifiedAbsence?: boolean;
  isEmailValid: boolean;
}

export interface IWorkshopParticipantWithStatus extends IWorkshopParticipant {
  status: ParticipantStatus;
  isSelected: boolean;
}

export interface IWorkshopDocument {
  _id: ObjectId;
  date: Date;
  mimeType: string;
  name: string;
  typeDoc: DocumentTypes;
  uploaded: boolean;
  url: string;
  isDeletable: boolean;
}

export interface IConvocationDate {
  _id: ObjectId;
  time: Date;
}

export enum IWorkshopStatus {
  OPEN = "Ouvert",
  TO_CLOSE = "À clôturer",
  CLOSED = "Clôturé",
  TO_PLANIFY = "À planifier",
}

export interface IWorkshop {
  _id: ObjectId;
  convocationTimes: IConvocationDate[];
  createdAt: Date;
  documents: IWorkshopDocument[];
  organisation: ObjectId;
  isDone: boolean;
  isCancelled: boolean;
  date?: Date;
  startTime?: Date;
  endTime?: Date;
  otherAnimators: Pick<IUser, "_id" | "firstName" | "lastName">[];
  participants: IWorkshopParticipant[];
  sessionType: string;
  updatedAt: Date;
  address?: IAddress;
  description?: string;
  endDate?: Date;
  mainAnimator?: Pick<IUser, "_id" | "firstName" | "lastName">;
  organizer?: string;
  owner?: Pick<IUser, "_id" | "firstName" | "lastName">;
  startDate?: Date;
  status?: IWorkshopStatus;
  supportCourse?: ObjectId;
  scheduledAppointmentReminder?: ObjectId;
}
